/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const clock = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8 5.5V8l2.5 2.5M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
    />
  </svg>
)
export default clock
